const compareByTargetGroups = (a, b) => {
    if (a.targetGroups < b.targetGroups) {
        return -1;
    } else if (a.targetGroups > b.targetGroups) {
        return  1;
    }

    return 0;
};

export const compareWishlistItems = (a, b, sortBy) => {
    switch (sortBy) {
        case 'wishlist_sort_last_added':
            return new Date(b.addedOn) - new Date(a.addedOn);
        case 'wishlist_sort_low_price':
            return parseFloat(a.productCardItem.priceComponentModel.currentPrice) - parseFloat(b.productCardItem.priceComponentModel.currentPrice);
        // case 'wishlist_sort_best_rated':
        //     return 0;
        case 'wishlist_sort_category_az':
            return compareByTargetGroups(a, b);
        case 'wishlist_sort_category_za':
            return compareByTargetGroups(b, a);
        case 'wishlist_sort_sale':
            const discountA = parseInt(a.productCardItem?.priceComponentModel?.discountInPercent ?? 0);
            const discountB = parseInt(b.productCardItem?.priceComponentModel?.discountInPercent ?? 0);
            return discountB - discountA;
        case 'wishlist_sort_availability':
            const availabilityOrder = { AVAILABLE: 1, TEMP: 2, SOLDOUT: 3 };

            const availabilityA = availabilityOrder[a.availability];
            const availabilityB = availabilityOrder[b.availability];

            if (availabilityA < availabilityB) {
                return -1;
            }
            if (availabilityA > availabilityB) {
                return 1;
            }
            return 0;
        default:
            return 0;
    }
};
